import React, {useEffect, useState} from "react";
import axios from "axios";
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import {Link} from 'react-router-dom';
import {baseUrl, formatDateTime} from '../Univ.js'
function OtDrugList(props) {
    const urlParams = new URLSearchParams(window.location.search);
    const type = urlParams.get("type");
    const [ipViewData, setIpViewData] = useState([]);
    useEffect(() => {
        fetchIpViewData();
    }, []);
    function fetchIpViewData() {
        const url = `${baseUrl}view-ip/?status=2`;
        axios.get(url)
            .then(response => {
                setIpViewData(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }
    const columns = [
        {
            field: 'ip_id', headerName: 'IP ID',
            renderCell: (params) => (
                <Link to={`/ip-pat-view/${params.row.id}/`}>
                    {params.value}
                </Link>
            ),
            width: 100,
        },
        {field: 'pat__pat_id', headerName: 'Pat Id', width: 40},
        {field: 'pat__patient', headerName: 'Patient', width: 150},
        {field: 'pat__age', headerName: 'Age', width: 10},
        {field: 'pat__mobile', headerName: 'Mobile', width: 100},
        {field: 'pat__address1', headerName: 'Address', width: 220},
        {field: 'adhar', headerName: 'Adhar', width: 120},
        {field: 'primary_consult__consultant', headerName: 'Consultant', width: 100},
        {field: 'room_no__room_no', headerName: 'Room No', width: 75},
        {field: 'payment', headerName: 'Payment', width: 100},
        {
            field: 'admit_date', headerName: 'Admitted On', width: 150,
            renderCell: (params) => (
                <span>{formatDateTime(params.value)}</span>
            ),
        },
    ];
    if (type === 'ot') {
        const returnColumn = {
            field: 'return',
            headerName: 'Return',
            width: 100,
            renderCell: (params) => {
                const patId = params.row.id;
                return (
                    <Link to={`/drug-pay-ot/${patId}`} target="_blank" className="btn btn-success">
                        OT Bill
                    </Link>
                );
            },
        };
        columns.splice(11, 0, returnColumn);
    }
    if (type === 'ip') {
        const returnColumn = {
            field: 'return',
            headerName: 'Return',
            width: 100,
            renderCell: (params) => {
                const patId = params.row.id;
                return (
                    <Link to={`/drug-pay-ip/${patId}`} target="_blank" className="btn btn-success">
                        IP Bill
                    </Link>
                );
            },
        };
        columns.splice(11, 0, returnColumn);
    }
    return (
        <section className="container mt-4">
            <div className="row">
                <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                    <i className="fa-solid fa-list" aria-hidden="true" style={{color: 'red'}}></i>
                    Inpatient List
                </h3>
                {ipViewData.length > 0 ? (
                    <div style={{height: '100%', width: '100%'}} className="mt-4">
                        <DataGrid
                            sx={{
                                boxShadow: 4,
                                border: 4,
                                borderColor: 'primary.light',
                                '& .MuiDataGrid-cell:hover': {
                                    color: 'primary.main',
                                },
                            }}
                            rows={ipViewData}
                            columns={columns}
                            pageSize={10}
                            slots={{toolbar: GridToolbar}}
                            autoHeight
                        />
                    </div>
                ) : (
                    <></>
                )}
            </div>
        </section>
    )
}
export default OtDrugList;
